import * as React from "react";
import {sticketTheme} from "../../theme/sticketTheme";
import {Restaurant} from "@mui/icons-material";
import logo from "../../assets/logos/LOGO_nero_Plesh.png"

export class ComponentToPrint extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        const { name, info, qrCode, mealInfo } = this.props;

        return (
            <div style={{
                padding: '4px',
                maxWidth: '218px',
                border: `5px solid ${sticketTheme.palette.secondary.main}`,
                borderRadius: '1rem',
                marginRight: '2px',
                marginBottom: '4px',
                paddingTop: '20px',
            }}>
                <style type="text/css" media="print">
                    {"\
   @page { size: a4 portrait; }\
"}
                </style>
                <img src={logo} height={'15px'} style={{objectFit: 'cover', maxWidth: '100px'}}/>
                <img alt="qr" src={qrCode} width="200" height="200"
                     style={{borderRadius: '0.5rem'}}
                />
                <div style={{textAlign: 'center', width: 200, display: 'grid', fontSize: '1rem', paddingInline: '4px'}}>
                    {/*<div style={{height: '4px', background: sticketTheme.palette.secondary.main}}/>*/}
                    <strong>{name}</strong>
                    <strong>{info}</strong>
                    {mealInfo ? <strong>{mealInfo || ''} <Restaurant/></strong> : null}
                </div>
            </div>
        );
    }
}

export class MultipleComponentToPrint extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        const { qrCodes, multiple } = this.props;
        //console.log("qrCodes:",qrCodes)

        return (<div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                margin: '20px',
                padding: '10px',
                transform: !multiple ? 'rotate(90deg)' : 'inherit'
            }}>
            {qrCodes.map((qr, i) => (
                <div key={i} style={{
                    padding: '4px',
                    maxWidth: '218px',
                    border: `5px solid lightgrey`,
                    //borderRadius: '1rem',
                    marginRight: '2px',
                    marginBottom: '4px',
                    paddingTop: '20px'
                }}>
                    {/*multiple ?
                        <style type="text/css" media="print">
                            {"\
   @page { size: a4; }\
"}
                        </style> : null*/}
                    <img src={logo} height={'15px'} style={{objectFit: 'cover', maxWidth: '100px'}}/>
                    <img alt="qr" src={qr.qrCode} width="200" height="200"
                         style={{borderRadius: '0.5rem'}}
                    />
                    <div style={{textAlign: 'center', width: 200, display: 'grid', fontSize: '1rem', paddingInline: '4px'}}>
                        {/*<div style={{height: '4px', background: sticketTheme.palette.secondary.main}}/>*/}
                        {qr.name}
                        {qr.info}
                        {qr.mealInfo ? <div>{qr.mealInfo || ''} <Restaurant fontSize={'1rem'}/></div> : null}
                    </div>
                </div>
            ))
            }</div>
        );
    }
}

export const QrCodeToPrint = React.forwardRef((props, ref) => {
    // eslint-disable-line max-len
    return <div style={{display: 'none'}}>
        <MultipleComponentToPrint ref={ref}
                                  qrCodes={props.qrCodes}
                                  multiple={props.multiple}
        />
    </div>;
});
